// Copyright (c) 2016 Deere & Company

import {
    addFile,
    deleteFile
} from './file-attachment';
import {
    onCreateClaim,
    updateClaimModalMode,
    updateCreateClaimModalVisibility
} from './create-claim-modal-visibility';
import {
    resetClaim,
    updateAdditionalComments,
    updateComments,
    updateFormValidation,
    updateMachineType,
    updateNoTravel,
    updatePlanName,
    updateRepairNumber,
    updateResponsibleAccount,
    updateServiceDate,
    updateServiceInterval,
    updateStickyHeaderVisibility,
    updateUseAmount,
    updateUseAmountUnit,
    updateWorkOrderOne,
    updateWorkOrderTwo
} from './claim-details';
import {
    resetConfirmationModal,
    updateConfirmationModal
} from './confirmation-modal';
import {copyAttachments} from '../../../shared/action-creators/copy-attachment';
import {copyClaim} from './copy-claim';
import {createClaim} from './validate-claim';
import {onEditClaim} from '../../../shared/action-creators/edit-claim';
import {readClaim} from './get-claim';
import {readClaimProduct} from './get-product-details';
import {readClaimTypes} from './get-claim-types';
import {readGoodsInstallationVatOptions} from '../../../shared/action-creators/get-goods-installation-vat-options';
import {readOpenMaintenancePlans} from './get-open-maintenance-plans';
import {readOpenServiceIntervals} from './get-open-service-intervals';
import {resetCkcCustomerFailure} from '../../../../shared/action-creators/customer-failed';
import {resetCustomerDetails} from './reset-customer-details';
import {resetLatestPerUnitMeasurements} from '../../../../shared/action-creators/latest-per-unit-measurements';
import {resetProductDetails} from './reset-product-details';
import {toggleWarrentyStatusModal} from '../../../shared/action-creators/warranty-status-modal';
import {updateGoodsInstallationVat} from './update-goods-installation-vat';
import {updateIsEditable} from './is-editable';
import {updatePin} from './pin';
import {updateSelectedAction} from './update-selected-action';
import {updateTemporaryObjectKey} from './update-temporary-object-key';
import {updateWarranties} from '../../../../product/details/action-creators/warranties';

export default {
    addFile,
    copyAttachments,
    copyClaim,
    createClaim,
    deleteFile,
    onCreateClaim,
    onEditClaim,
    readClaim,
    readClaimProduct,
    readClaimTypes,
    readGoodsInstallationVatOptions,
    readOpenMaintenancePlans,
    readOpenServiceIntervals,
    resetCkcCustomerFailure,
    resetClaim,
    resetConfirmationModal,
    resetCustomerDetails,
    resetLatestPerUnitMeasurements,
    resetProductDetails,
    toggleWarrentyStatusModal,
    updateAdditionalComments,
    updateClaimModalMode,
    updateComments,
    updateConfirmationModal,
    updateCreateClaimModalVisibility,
    updateFormValidation,
    updateGoodsInstallationVat,
    updateIsEditable,
    updateMachineType,
    updateNoTravel,
    updatePin,
    updatePlanName,
    updateRepairNumber,
    updateResponsibleAccount,
    updateSelectedAction,
    updateServiceDate,
    updateServiceInterval,
    updateStickyHeaderVisibility,
    updateTemporaryObjectKey,
    updateUseAmount,
    updateUseAmountUnit,
    updateWarranties,
    updateWorkOrderOne,
    updateWorkOrderTwo
};



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/index.js